import React from "react";
import { compose } from "recompose";
import { connect } from "react-redux";
import { Flex, Box } from "@chakra-ui/react";
import { isFreemium } from "src/modules/auth/duck/selectors";

import { withPurchase } from "src/modules/purchase/PurchaseContext";
import CommandsFlow from "src/modules/command/CommandsFlow";
import PopoverView from "src/components/PopoverView";

import CloseGroupButton from "../CloseGroupButton";
import ButtonsGroup from "../../ControlButtons/ButtonsGroup";
import ManageCommandsButton from "./ManageCommandsButton";
import CommandButton from "./CommandButton";
import NoCommandsButton from "./NoCommandsButton";
import PttButton from "../PttButton";
import SeeMeButton from "./SeeMeButton";
import environment from "src/utils/environment";

class CommandsGroup extends React.Component {
  state = { renderCommandsFlow: false };

  togglePushToTalk = () => {
    const { parentStation } = this.props;
    const {
      commandPlayerState,
      pushToTalkState,
      togglePushToTalk,
      stopCommand
    } = parentStation;

    if (pushToTalkState === "off" && commandPlayerState.commandId) {
      stopCommand();
    }
    togglePushToTalk();
  };

  playCommand = (commandId) => {
    const { parentStation } = this.props;
    const { pushToTalkState, togglePushToTalk } = parentStation;
    if (pushToTalkState === "starting") return;
    if (pushToTalkState === "on") {
      togglePushToTalk();
    }
    parentStation.playCommand(commandId);
  };

  toggleCommandsFlow = () =>
    this.setState(({ renderCommandsFlow }) => ({
      renderCommandsFlow: !renderCommandsFlow
    }));

  render() {
    const { renderCommandsFlow } = this.state;
    const {
      in: inProp,
      activity,
      isDarkMode,
      closeGroup,
      scrollToBottom,
      parentStation,
      commands = [],
      isFreeVersion,
      purchase
    } = this.props;
    const {
      stopCommand,
      resetCommandPlayer,
      toggleSeeMe,
      isBabyStationFamilyDevice,
      primaryStation
    } = parentStation;
    const {
      mode,
      pushToTalkState,
      opusRecorder,
      seeMeState,
      commandPlayerState
    } = primaryStation;
    const openCommandsFlowButton =
      commands.length === 0 ? (
        <NoCommandsButton
          mb={["12px", "16px", "20px"]}
          isDarkMode={isDarkMode}
          mode={mode}
          activity={activity}
          openCommandFlow={this.toggleCommandsFlow}
        />
      ) : (
        <ManageCommandsButton
          mb={["12px", "16px", "20px"]}
          onClick={this.toggleCommandsFlow}
          isDarkMode={isDarkMode}
          mode={mode}
          activity={activity}
        />
      );

    const commandsList = commands.map((command) => {
      let status = "resting";
      const { commandId, playing, currentTime } = commandPlayerState;
      if (commandId === command.objectId) {
        status = playing ? "playing" : "loading";
      }
      return (
        <CommandButton
          root={{ mb: ["12px", "16px", "20px"] }}
          key={command.objectId}
          command={command}
          isDarkMode={isDarkMode}
          mode={mode}
          activity={activity}
          playCommand={() => {
            isFreeVersion
              ? purchase.open({ content: "playAndRecord" })
              : this.playCommand(command.objectId);
          }}
          stopCommand={stopCommand}
          status={status}
          initialReplayTime={currentTime}
          resetCommandPlayer={resetCommandPlayer}
        />
      );
    });

    return (
      <>
        <PopoverView isOpen={renderCommandsFlow}>
          <CommandsFlow
            onClose={this.toggleCommandsFlow}
            initialStep="commands"
          />
        </PopoverView>
        <ButtonsGroup onEntering={scrollToBottom} in={inProp}>
          <Flex
            py="2px"
            width={["40px", "56px", "64px"]}
            alignItems="center"
            flexDirection="column"
          >
            {isBabyStationFamilyDevice({ jid: primaryStation.jid }) &&
            environment.isBarkio ? (
              <>
                {openCommandsFlowButton}
                {commandsList}
              </>
            ) : null}
            <PttButton
              root={{ mb: ["12px", "16px", "20px"] }}
              isDarkMode={isDarkMode}
              mode={mode}
              activity={activity}
              togglePushToTalk={this.togglePushToTalk}
              state={pushToTalkState}
              noiseMeter={opusRecorder && opusRecorder.noiseMeter}
              bg={mode === "video" ? "black20" : "primary"}
              showMicrophoneIcon
            />
            {mode === "video" && (
              <SeeMeButton
                mb={["12px", "16px", "20px"]}
                toggleSeeMe={toggleSeeMe}
                state={seeMeState}
              />
            )}
            <Box flex="0 0 auto">
              <CloseGroupButton
                isDarkMode={isDarkMode}
                mode={mode}
                activity={activity}
                onClick={closeGroup}
              />
            </Box>
          </Flex>
        </ButtonsGroup>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    isFreeVersion: isFreemium(state)
  };
}
const enhance = compose(withPurchase, connect(mapStateToProps));

export default enhance(CommandsGroup);
